import type { ReactNode } from 'react';
import type { WizardStep } from '../types/wizard.types';

interface Props {
  title: string;
  subtitle?: string;
  current: WizardStep;
  children: ReactNode;
  footer?: ReactNode;
}

const STEP_ORDER: WizardStep[] = ['variant', 'yellow', 'green', 'review', 'signatures', 'insert', 'summary'];
const STEP_LABELS: Record<WizardStep, string> = {
  variant: 'Вариант',
  yellow: 'Сотрудник',
  green: 'Клиент',
  review: 'Договор',
  signatures: 'Подписи',
  insert: 'Вставка',
  summary: 'Итог',
};

export function StepShell({ title, subtitle, current, children, footer }: Props) {
  const currentIdx = STEP_ORDER.indexOf(current);
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b px-6 py-4 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
        </div>
        <div className="flex gap-1">
          {STEP_ORDER.map((s, i) => (
            <div
              key={s}
              className={`h-2 w-8 rounded-full transition ${
                i <= currentIdx ? 'bg-primary' : 'bg-slate-200'
              }`}
              title={STEP_LABELS[s]}
            />
          ))}
        </div>
      </header>
      <main className="flex-1 px-4 md:px-8 py-6 max-w-5xl mx-auto w-full">{children}</main>
      {footer && <footer className="bg-white border-t px-6 py-4">{footer}</footer>}
    </div>
  );
}
